"use client";

import {
    Breadcrumb,
    BreadcrumbEllipsis,
    BreadcrumbItem,
    BreadcrumbButton,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useStorageQuery } from "../../../hooks/storageQueryProvider";
import { LoaderCircle } from "lucide-react";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

const selectedFile: any = null;

export default function StorageBreadcrumbs() {
    const { dir } = useLocale();
    const {
        parentFolder,
        changeParentFolder,
        currentStoragePath,
        loadingCurrentStoragePath,
    } = useStorageQuery();

    if (!parentFolder) return null;

    const separator = "/";

    return (
        <Breadcrumb>
            <BreadcrumbList>
                <BreadcrumbItem>
                    <BreadcrumbButton onClick={() => changeParentFolder(null)}>
                        {t("storage.breadcrumbs.root")}
                    </BreadcrumbButton>
                </BreadcrumbItem>
                <BreadcrumbSeparator>{separator}</BreadcrumbSeparator>
                {(loadingCurrentStoragePath ||
                    !!currentStoragePath?.length) && (
                    <>
                        <BreadcrumbItem>
                            {currentStoragePath?.length ? (
                                <DropdownMenu dir={dir}>
                                    <DropdownMenuTrigger className="flex items-center gap-1">
                                        <BreadcrumbEllipsis className="h-4 w-4" />
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent align="start">
                                        {currentStoragePath.map((folder) => (
                                            <DropdownMenuItem
                                                key={folder.id}
                                                onClick={() =>
                                                    changeParentFolder(folder)
                                                }
                                                className="max-w-[200px] truncate"
                                            >
                                                {folder.name}
                                            </DropdownMenuItem>
                                        ))}
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            ) : (
                                <LoaderCircle className="size-4 animate-spin" />
                            )}
                        </BreadcrumbItem>
                        <BreadcrumbSeparator>{separator}</BreadcrumbSeparator>
                    </>
                )}
                <BreadcrumbItem>
                    <BreadcrumbButton
                        title={parentFolder.name}
                        className="max-w-[200px] truncate"
                    >
                        {parentFolder.name}
                    </BreadcrumbButton>
                </BreadcrumbItem>
                {selectedFile && (
                    <>
                        <BreadcrumbSeparator>{separator}</BreadcrumbSeparator>
                        <BreadcrumbItem>
                            <BreadcrumbPage className="max-w-[200px] truncate">
                                {selectedFile.name}
                            </BreadcrumbPage>
                        </BreadcrumbItem>
                    </>
                )}
            </BreadcrumbList>
        </Breadcrumb>
    );
}
